import { useEffect } from "react";
import { toast, Toaster as SonnerToaster, type ToasterProps } from "sonner";

import { toasterProps } from "~/utils/toast";

export const Toaster: React.FC<ToasterProps> = (props) => {
  useEffect(() => {
    const message = new URLSearchParams(window.location.search).get("message");
    if (message) {
      // show success message
      toast.success(message);

      // remove message from query params after showing it
      const url = new URL(window.location.href);
      url.searchParams.delete("message");
      history.replaceState(null, "", url);
    }
  }, []);

  return <SonnerToaster {...toasterProps} {...props} />;
};
